import CustomCard from 'components/card/CustomCard'
import CustomCardHeader from 'components/card/CustomCardHeader'
import ToggleSwitch from 'components/toggleSwitch/ToggleSwitch'
import { useDispatch, useSelector } from 'react-redux'
import { updateRemoteConfig } from 'redux/slices/remoteConfigSlice'

const SavedCardSection = () => {
  const dispatch = useDispatch()
  const { loading, processing, remoteConfig } = useSelector(
    (state) => state.remoteConfig,
  )

  const card = remoteConfig?.config?.card ?? {}
  const savedCard = card.saved_card ?? {}

  const updateSavedCard = (value) => {
    dispatch(
      updateRemoteConfig({
        configType: 'Saved card',
        configPayload: {
          config: {
            card: {
              ...card,
              saved_card: { ...savedCard, ...value },
            },
          },
        },
      }),
    )
  }

  return (
    <div className="flex-1">
      <CustomCard>
        <CustomCardHeader contentPosition="none">
          <div className="w-full flex items-center justify-between">
            <h2 className="text-white text-2xl">Saved Card</h2>
            <ToggleSwitch
              isChecked={savedCard.active ?? false}
              onChange={() =>
                !processing &&
                !loading &&
                updateSavedCard({ active: !savedCard.active })
              }
            />
          </div>
        </CustomCardHeader>
      </CustomCard>
    </div>
  )
}

export default SavedCardSection
